/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import LadeTypenUtil from "../../Cloud/DomainDrivenDesign/Queries/LadeTypenUtil";
import { Feld, Typ } from "../../Cloud/DomainDrivenDesign/Queries/PromiseLadeTypen";
import IAppContext from "../Components/AppContext/IAppContext";
import AppSnackbarItemFactory from "../Components/AppSnackbarContext/AppSnackbarItemFactory";
import IAppSnackbar from "../Components/AppSnackbarContext/IAppSnackbar";
import { useAppContext } from "./../Components/AppContext";
import { useAppSnackbar } from "./../Components/AppSnackbarContext";
import AppSnackbarItem from "./../Components/AppSnackbarContext/AppSnackbarItem";
import Pflichtangabe from "./Pflichtangabe";

export default class CommandInputValidator {
    private readonly _pflichtangabe: Pflichtangabe;
    private readonly _appContext: IAppContext;
    private readonly _snackbar: IAppSnackbar;

    constructor() {
        this._appContext = useAppContext();
        this._snackbar = useAppSnackbar();
        this._pflichtangabe = new Pflichtangabe();
    }

    public async validate(commandName: string, input: any): Promise<boolean> {
        const typen = await this._appContext.typen;
        const typ: Typ = LadeTypenUtil.findeTyp(typen, commandName);
        const items: Array<AppSnackbarItem> = [];
        this.validateInternal(typen, items, typ, commandName, [], input);
        this._snackbar.push(items);
        return items.length <= 0;
    }

    private toAppSnackbarItem(
        commandName: string,
        path: string[],
        message: string
    ): AppSnackbarItem {
        return new AppSnackbarItemFactory().create({
            source: commandName,
            message,
            level: "Error",
            path: [commandName, ...path],
        })
    }

    private validateInternal(typen: Typ[], items: Array<AppSnackbarItem>, typ: Typ, commandName: string, path: string[], input: any): void {
        for (const feld of typ.felder) {
            const value = input[feld.bezeichnung];
            if (LadeTypenUtil.hatRegeln(feld, [Pflichtangabe.regelName])) {
                const message = this._pflichtangabe.validate(value);
                if (message) {
                    items.push(this.toAppSnackbarItem(commandName, [...path, feld.bezeichnung], message));
                }
            }

            if (value) {
                this.validateSubType(typen, items, feld, commandName, [...path], value);
            }
        }
    }

    private validateSubType(typen: Typ[], items: Array<AppSnackbarItem>, feld: Feld, commandName: string, path: string[], value: any) {
        if (feld.hatGraphQLTypName) {
            path.push(feld.bezeichnung);
            if (feld.istObjekt) {
                this.validateInternal(typen, items, LadeTypenUtil.findeTyp(typen, feld.graphQLTypName), commandName, path, value);
            } else if (feld.istListe) {
                for (let index = 0; index < value.length; index++) {
                    const typ = LadeTypenUtil.findeTyp(typen, feld.graphQLTypName);

                    path.push(index.toString());
                    this.validateInternal(typen, items, typ, commandName, path, value[index]);

                    // Der Index muss hier für den nächsten Branch des Trees zurückgesetzt
                    // werden, da sonst falsche Pfadkonstellationen wie
                    // ['Seminare_AenderePaketpereis', 'paketpreispositionen', '0', '1', 'preisId']
                    // entstehen.
                    path.pop()
                }
            }
        }
    }
}
